import axios from '@/libs/api.request'

export const shopList = () => {
    return axios.request({
        url: '/api/admin/shop/getAllShopList',
        method: 'post'
    })
}